import { useState, useEffect } from "react"
import { useInstallPrompt } from "../hooks/useInstallPrompt"

interface Props {
  language: "tr" | "en"
  show: boolean
}

export const InstallPrompt = ({ language, show }: Props) => {
  const { canInstall, showPrompt } = useInstallPrompt()
  const [isIOS, setIsIOS] = useState(false)
  const [showIOSGuide, setShowIOSGuide] = useState(false)
  const [dismissed, setDismissed] = useState(false)

  useEffect(() => {
    const ios = /iphone|ipad|ipod/i.test(navigator.userAgent)
    const standalone = (window.navigator as any).standalone
    if (ios && !standalone) setIsIOS(true)
  }, [])

  if (!show) return null
  if (dismissed) return null
  if (!canInstall && !isIOS) return null

  const t = language === "tr" ? {
    title: "Bu senin günlük ritüelin olabilir.",
    sub: "Ana ekrana ekle, her gün 2 dakika.",
    btn: "Ana Ekrana Ekle",
    dismiss: "Şimdi değil",
    iosTitle: "Ana ekrana eklemek için:",
    iosSteps: "Safari'de alt menüdeki 'Paylaş' ikonuna dokun → 'Ana Ekrana Ekle' seçeneğini seç → 'Ekle' butonuna dokun",
    close: "Tamam",
  } : {
    title: "This could be your daily ritual.",
    sub: "Add to home screen, 2 minutes every day.",
    btn: "Add to Home Screen",
    dismiss: "Not now",
    iosTitle: "To add to home screen:",
    iosSteps: "Tap the 'Share' icon in Safari → Select 'Add to Home Screen' → Tap 'Add'",
    close: "Got it",
  }

  return (
    <div style={{
      marginTop: "24px",
      padding: "20px",
      borderRadius: "16px",
      background: "rgba(255,255,255,0.03)",
      border: "1px solid rgba(123,92,255,0.2)",
    }}>
      {!showIOSGuide ? (
        <div>
          <div style={{ fontSize: "15px", fontWeight: "500", color: "var(--text-primary)", marginBottom: "6px" }}>
            {t.title}
          </div>
          <div style={{ fontSize: "13px", color: "var(--text-secondary)", marginBottom: "16px" }}>
            {t.sub}
          </div>
          <button
            onClick={() => isIOS ? setShowIOSGuide(true) : showPrompt()}
            className="btn-primary"
            style={{ marginBottom: "8px" }}
          >
            {t.btn}
          </button>
          <button onClick={() => setDismissed(true)} className="btn-secondary">
            {t.dismiss}
          </button>
        </div>
      ) : (
        <div>
          <div style={{ fontSize: "14px", fontWeight: "500", color: "var(--text-primary)", marginBottom: "12px" }}>
            {t.iosTitle}
          </div>
          <div style={{ fontSize: "13px", color: "var(--text-secondary)", lineHeight: "1.8", marginBottom: "16px" }}>
            {t.iosSteps}
          </div>
          <button onClick={() => setDismissed(true)} className="btn-primary">
            {t.close}
          </button>
        </div>
      )}
    </div>
  )
}